import { useState, RefObject } from "react";
import useIntersectionObserver, {
  IntersectionObserverOptions,
} from "./useIntersectionObserver";

const useOnScreen = (
  ref: RefObject<Element>,
  options: IntersectionObserverOptions = {}
): boolean => {
  const [isIntersecting, setIntersecting] = useState(false);

  useIntersectionObserver(ref, setIntersecting, options);

  return isIntersecting;
};

export default useOnScreen;
